module.exports = __webpack_public_path__ + "1205c3dac9d9d577ed7071e7b74306cb.png";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/Sec-3/sec-3_object.png
// module id = ./app/containers/StaticPage/ComeBack/assets/Sec-3/sec-3_object.png
// module chunks = 40